import { DEV_HOSTNAMES, getOrganization, ORGANIZATIONS_MAP, setOrgOverride } from "../../utils/getOrganization";
import { OrganizationKey } from "../../utils/orgConfig";

export const DevOrgSwitcher = () => {
  if (!DEV_HOSTNAMES.includes(window.location.hostname)) return null;

  return (
    <select
      onChange={(e) => setOrgOverride(e.target.value as OrganizationKey)}
      style={{ position: "fixed", bottom: 1, right: 4, zIndex: 9999 }}
      value={getOrganization().key}
    >
      {Object.keys(ORGANIZATIONS_MAP).map((orgKey) => (
        <option key={orgKey} value={orgKey}>
          {orgKey}
        </option>
      ))}
    </select>
  );
};
